import styled from 'styled-components';
import Price from 'js/components/core/Price';

export default styled(Price)`
  line-height: 1.0rem;
  color: black;
  font-weight: normal;
  font-size: small;
  padding-top: 1% !important
`;
